import React from 'react';
import PropTypes from 'prop-types';
import TabGroup from './ui/TabGroup';
import BookingsModalDetails from './BookingsModalDetails';
import BookingsModalHost from './BookingsModalHost';
import BookingsModalQuestionnaire from './BookingsModalQuestionnaire';



class BookingsModal extends React.Component{

    state = {
        booking: {...this.props.booking},
        currentTab: 'Details'
    };

    changeTab = (tab) => {
        this.setState({ currentTab: tab });
    };

    updateBooking = (key, value) => {
        const booking = {...this.state.booking};
        booking[key] = String(value);
        this.setState({booking});
    };

    saveBooking = (e) => {
        e.preventDefault();
        const booking = this.state.booking;
        this.props.updateBooking(booking, this.props.bookingKey);
    };

    addRepeatItem = (itemName) => {
        const booking = {...this.state.booking};
        const timestamp = Date.now();
        if(!booking[itemName]) {
            booking[itemName] = {};
        }
        booking[itemName]['b'+timestamp] = '';
        this.setState({booking});
    };

    removeRepeatItem = (itemName, id) => {
        const booking = {...this.state.booking};
        booking[itemName][id] = null;
        this.setState({booking});
    };

    updateRepeatItem = (itemName, id, item) => {
        const booking = {...this.state.booking};
        if(!booking[itemName][id]) {
            booking[itemName][id] = '';
        }
        booking[itemName][id] = item.keyName;
        this.setState({booking});
    };

    renderTitle = () => {
        if(this.props.newBooking) {
            return 'Add booking';
        } else {
            return 'Edit booking';
        }
    };

    renderTabPanels = () => {
        switch(this.state.currentTab) {
            case 'Details':
                return <BookingsModalDetails booking={this.state.booking} updateBooking={this.updateBooking} />;
            case 'Host details':
                return <BookingsModalHost booking={this.state.booking} updateBooking={this.updateBooking} />;
            case 'Questionnaire':
                return <BookingsModalQuestionnaire booking={this.state.booking} updateBooking={this.updateBooking} addQuestion={this.addRepeatItem} updateQuestion={this.updateRepeatItem} removeQuestion={this.removeRepeatItem}/>;
            default:
                return null;
        }
    };

    render() {
        return (
            <div className="modal" role="dialog" onClick={this.props.closeBookingModal}>
                <div className="modal-dialog modal-lg" role="document" onClick={(e) => {e.stopPropagation()}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.renderTitle()}</h5>
                            <button type="button" className="close" onClick={this.props.closeBookingModal}>
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form ref={(input) => this.form = input} onSubmit={(e) => {this.saveBooking(e)}}>
                            <div className="modal-body">
                                <TabGroup tabs={['Details', 'Host details', 'Questionnaire']} currentTab={this.state.currentTab} onChange={this.changeTab} />

                                {this.renderTabPanels()}
                            </div>
                            <div className="modal-footer flex-between">
                                {this.props.newBooking ? <div /> : <button type="button" className="btn btn-primary btn-with-icon btn-delete" onClick={e => this.props.deleteBooking(this.props.bookingKey)}><i className="material-icons">delete</i>Delete</button>}

                                <div>
                                    <button type="button" className="btn btn-secondary btn-with-icon" onClick={this.props.closeBookingModal}><i className="material-icons">cancel</i>Cancel</button>
                                    <button type="submit" className="btn btn-primary btn-with-icon"><i className="material-icons">save</i>Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

BookingsModal.propTypes ={
    booking: PropTypes.object.isRequired,
    bookingKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    closeBookingModal: PropTypes.func.isRequired,
    deleteBooking: PropTypes.func.isRequired,
    updateBooking: PropTypes.func.isRequired,
    newBooking: PropTypes.bool.isRequired
}

export default BookingsModal;


/** WEBPACK FOOTER **
 ** ./src/components/BookingsModal.js
 **/